import { some } from 'underscore';

export const hasFBOAuthError = (error) => {
  if (!error || !error.errors || error.errors.length === 0) {
    return false;
  }

  return some(error.errors, err => err && err.Code === 'SmartPageGetFbPageOAuthError');
};
